import { render, staticRenderFns } from "./ChargingpointAttachments.vue?vue&type=template&id=9658945a&scoped=true&"
import script from "./ChargingpointAttachments.vue?vue&type=script&lang=js&"
export * from "./ChargingpointAttachments.vue?vue&type=script&lang=js&"
import style0 from "./ChargingpointAttachments.vue?vue&type=style&index=0&id=9658945a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9658945a",
  null
  
)

export default component.exports